import { AccordionItem } from './models/accordion-item.model';

export interface CoachingCardRepState {
    pending: {
        reload?: boolean;
        hasData?: boolean;
    };
    dataset?: AccordionItem[];
}

export const defaultState = (): CoachingCardRepState => ({
    pending: {},
});
